<script>
import KITSGoBackButton from 'fwkits-core-presentation-vue/components/Buttons/KITSGoBackButton'

export default {

    name: "mon-go-back-button",
    extends: KITSGoBackButton,
    props: {
      size: {
        type: String,
        default: "",
        description: "Button size lg|sm"
      },   
    }
}

</script>